((g) => {
  const dl = g.dataLayer = g.dataLayer || [];
  g.gtag = g.gtag || ((...a) => dl.push(a));

  if (!g.window) return;

  const w = g, d = w.document, n = w.navigator, s = w.screen, l = w.localStorage;
  const now = () => Date.now() / 1e3 | 0;
  const rnd = () => Math.random() * 2e9 | 0;
  const enc = encodeURIComponent;
  const _ = (k, v) => v ? l.setItem('ga4_' + k, v) : l.getItem('ga4_' + k);
  
  let tid, seq = 1, pid = rnd();

  const track = (en, params = {}) => {
    if (!tid) return;
    
    let last = +_('l') || 0, sid = _('sid'), sct = +_('sct') || 0, cid = _('cid');
    let isStart = !sid || (now() - last > 1800);

    if (isStart) {
      sid = now();
      sct++;
      _('sid', sid);
      _('sct', sct);
    }
    _('l', now());
    if (!cid) {
      cid = rnd() + '.' + sid;
      _('cid', cid);
    }

    let q = `v=2&tid=${tid}&cid=${cid}&sid=${sid}&sct=${sct}&seg=1&_p=${pid}&_s=${seq++}&en=${enc(en)}&dl=${enc(d.location.href.split('#')[0])}&dr=${enc(d.referrer)}&dt=${enc(d.title)}&ul=${(n.language || '').toLowerCase()}&sr=${s.width}x${s.height}`;
    
    if (isStart) q += `&_ss=1${sct == 1 ? '&_fv=1' : ''}`;
    
    for (let k in params) {
      if (params[k] != null) q += `&ep.${k}=${enc(params[k])}`;
    }

    const u = 'https://www.google-analytics.com/g/collect?' + q;
    (n.sendBeacon && n.sendBeacon(u)) || fetch(u, {method: 'POST', keepalive: !0});
  };

  const process = (...a) => {
    let [c, i, o] = a;
    if (c == 'config') {
      tid = i;
      if (!o || o.send_page_view !== !1) track('page_view');
    } else if (c == 'event') {
      track(i, o);
    }
  };

  const oldPush = dl.push.bind(dl);
  w.gtag = (...a) => {
    process(...a);
    oldPush(a);
  };

  dl.forEach(a => process(...a));
})(typeof globalThis < 'u' ? globalThis : typeof self < 'u' ? self : window);
